import API from "Common/Client/endpoint";
import api from "Common/Client/Interceptor";

export const fetchProAdminDashboardData = async (token) => {
  try {
    const response = await api.get("/indv/Dashboard/SuperAdminDashboard", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("................ Pro admin data:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching PRO Admin dashboard data:", error);
    throw error;
  }
};

